/**
 * EditorSelect — labeled dropdown select
 */

interface EditorSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}

export function EditorSelect({ label, value, onChange, options }: EditorSelectProps) {
  return (
    <div className="field">
      <label className="field-label">{label}</label>
      <select
        className="field-input field-select"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
